import React from 'react';

const ClinicInfoPanel = ({ theme }) => {
    return (
        <div className="notifications-panel mt-4">
            <div className="notifications-panel__header">
                <span className="d-flex align-items-center gap-2">
                    <i className="bi bi-info-circle"></i>
                    Clinic Information
                </span>
            </div>
            <div className="notifications-panel__body">
                <div className="mb-4">
                    <h6 className="fw-semibold mb-3">Clinic Information <small className="text-muted fw-normal">(Read-only - managed from Info tab)</small></h6>
                    <div className="row">
                        <div className="col-md-6">
                            <label className="form-label">Clinic Name</label>
                            <input
                                type="text"
                                className="form-control"
                                value={theme.clinicInfo.name}
                                readOnly
                                disabled
                            />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label">Tagline</label>
                            <input
                                type="text"
                                className="form-control"
                                value={theme.clinicInfo.tagline}
                                readOnly
                                disabled
                            />
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-md-12">
                            <label className="form-label">Address</label>
                            <input
                                type="text"
                                className="form-control mb-2"
                                value={theme.clinicInfo.address.street}
                                readOnly
                                disabled
                                placeholder="Street"
                            />
                            <div className="row">
                                <div className="col-md-3">
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={theme.clinicInfo.address.city}
                                        readOnly
                                        disabled
                                        placeholder="City"
                                    />
                                </div>
                                <div className="col-md-3">
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={theme.clinicInfo.address.province}
                                        readOnly
                                        disabled
                                        placeholder="Province"
                                    />
                                </div>
                                <div className="col-md-3">
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={theme.clinicInfo.address.postalCode}
                                        readOnly
                                        disabled
                                        placeholder="Postal Code"
                                    />
                                </div>
                                <div className="col-md-3">
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={theme.clinicInfo.address.country}
                                        readOnly
                                        disabled
                                        placeholder="Country"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-md-4">
                            <label className="form-label">Phone</label>
                            <input
                                type="text"
                                className="form-control"
                                value={theme.clinicInfo.contact.phone}
                                readOnly
                                disabled
                            />
                        </div>
                        <div className="col-md-4">
                            <label className="form-label">Email</label>
                            <input
                                type="text"
                                className="form-control"
                                value={theme.clinicInfo.contact.email}
                                readOnly
                                disabled
                            />
                        </div>
                        <div className="col-md-4">
                            <label className="form-label">Website</label>
                            <input
                                type="text"
                                className="form-control"
                                value={theme.clinicInfo.contact.website}
                                readOnly
                                disabled
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ClinicInfoPanel;
